import { fvDateUtc } from '@fv/dates'

import type { CredentialDetail } from '../models/account-carrier.ts'

export function needsShipperAttention({
  code,
  details,
}: {
  code?: string
  details?: CredentialDetail[]
  isBeta?: boolean
}) {
  if (code === 'upgf' || code === 'tfin') {
    return !details?.some(
      d =>
        d.type === 'refresh-token' &&
        d.value &&
        fvDateUtc(d.expires).isAfter(fvDateUtc()),
    )
  }

  if (code === 'upss') {
    const hasIdAndSecret =
      details?.some(d => d.type === 'client-id' && d.value) &&
      details?.some(d => d.type === 'client-secret' && d.value)
    return !hasIdAndSecret
  }

  if (code === 'fxfe') {
    const hasKeyAndSecret =
      details?.some(d => d.type === 'child-key' && d.value) &&
      details?.some(d => d.type === 'child-secret' && d.value)
    return !hasKeyAndSecret
  }

  return false
}
